import { render, staticRenderFns } from "./NsSlottedDropdown.vue?vue&type=template&id=dc3bdee2&scoped=true&"
import script from "./NsSlottedDropdown.vue?vue&type=script&lang=js&"
export * from "./NsSlottedDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NsSlottedDropdown.vue?vue&type=style&index=0&id=dc3bdee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3bdee2",
  null
  
)

export default component.exports